/**
 * The pilot's **active mech** resolution — a single source the reducer, CLI, and UI all import
 * so "which mech is active" can't drift between them.
 *
 * `PilotData.activeMechId` is an *explicit* pick (`set_active_mech`), but it's optional and may
 * dangle (point at a since-deleted mech). `resolveActiveMechId` collapses all of that to the mech
 * that's actually active right now: the explicit pick when it still names a real mech, else the
 * first mech, else `undefined` (a mechless pilot). Because the fallback is computed, `delete_mech`
 * never has to clear the field and undo restores the active mech for free.
 */
import type { PilotData } from "./types";

/** The id of the pilot's active mech (explicit pick if it still exists, else the first mech). */
export function resolveActiveMechId(pilot: PilotData): string | undefined {
  if (pilot.activeMechId && pilot.mechs.some((m) => m.id === pilot.activeMechId)) {
    return pilot.activeMechId;
  }
  return pilot.mechs[0]?.id;
}
